function isEmpty(value: unknown): boolean {
  // null, undefined, empty string
  if (value === null || value === undefined || value === '') return true;

  // empty array
  if (Array.isArray(value)) return value.length === 0;

  // Date型は空とみなさない
  if (value instanceof Date) return false;

  if (typeof value === 'object' && value !== null) {
    return Object.keys(value).length === 0;
  }

  return false;
}

function isPlainObject(val: unknown): val is Record<string, unknown> {
  return (
    typeof val === 'object' &&
    val !== null &&
    Object.getPrototypeOf(val) === Object.prototype
  );
}

// remove empty values from object
export function removeEmptyValues<T extends Record<string, unknown>>(
  obj: T
): Partial<T> {
  const result: Partial<T> = {};

  for (const [key, value] of Object.entries(obj)) {
    const formattedValue = isPlainObject(value)
      ? removeEmptyValues(value)
      : value;

    if (isEmpty(formattedValue)) continue;

    result[key as keyof T] = formattedValue as T[keyof T];
  }

  return result;
}
